module.exports = {
          srcSet: __webpack_public_path__ + "7d885300.jpg"+" 700w"+","+__webpack_public_path__ + "69deb02d.jpg"+" 1400w"+","+__webpack_public_path__ + "8af62f50.jpg"+" 2100w"+","+__webpack_public_path__ + "dc0d9289.jpg"+" 2456w",
          images:[ {path: __webpack_public_path__ + "7d885300.jpg",width: 700,height: 465},{path: __webpack_public_path__ + "69deb02d.jpg",width: 1400,height: 930},{path: __webpack_public_path__ + "8af62f50.jpg",width: 2100,height: 1395},{path: __webpack_public_path__ + "dc0d9289.jpg",width: 2456,height: 1632}],
          src: __webpack_public_path__ + "7d885300.jpg",
          toString:function(){return __webpack_public_path__ + "7d885300.jpg"},
          
          width: 700,
          height: 465
        }